/**
 * Smoothly scrolls the window so that the given page-absolute rect is vertically centered,
 * but only when the element is outside the comfortable viewport zone (top/bottom 20%).
 */
export function scrollIntoComfortZone(pageRect: DOMRect): void {
  const elementCenter = pageRect.top + pageRect.height / 2;
  const viewportCenter = elementCenter - window.scrollY;
  const topThreshold = window.innerHeight * 0.2;
  const bottomThreshold = window.innerHeight * 0.8;

  if (viewportCenter < topThreshold || viewportCenter > bottomThreshold) {
    const scrollTarget = elementCenter - window.innerHeight / 2;
    window.scrollTo({ top: scrollTarget, behavior: 'smooth' });
  }
}
